import produce from 'immer';

import moment from 'moment';
import {
  LOGINLOG_LIST,
  LOGINLOG_LIST_REQUEST, LOGINLOG_PAGE_RESET,
  SET_LOGINLOG_PAGINATION,
  SET_TOTAL_COUNT
} from '../../constants/log/loginLogConstants';

const initialState = {
  page: 1,
  pageLength: 10,
  beginDate: moment().utc().subtract(3, 'days').format('YYYY-MM-DDT00:00:00'),
  endDate: moment().utc().format('YYYY-MM-DDT23:59:59'),
  searchString: '',
  totalCount: 0,
};

const loginLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case LOGINLOG_LIST_REQUEST:
      break;
    case LOGINLOG_LIST:
      draft.list = action.list;
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_LOGINLOG_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.beginDate = action.beginDate;
      draft.endDate = action.endDate;
      draft.searchString = action.searchString;
      break;
    case LOGINLOG_PAGE_RESET:
      draft.page = 1;
      break;
    default:
      break;
  }
});

export default loginLogReducer;
